import{styled as o}from"styled-components";const t=o.ul`
  padding-left: 8px;
  margin-top: 0px;
  margin-bottom: 0px;
`;export{t as MessageList};
